import PropTypes from 'prop-types';
import React, { useState } from 'react';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import TrueLinkTextInput from 'react/shared/components/true_link/main/form/TrueLinkTextInput';
import PasswordAdornment from 'react/signups/card/common/PasswordAdornment';

export default function FamilyForm({ onChange, setFieldTouched, values }) {
  const [showPassword, setShowPassword] = useState(false);
  const handleToggleVisibility = () => setShowPassword(!showPassword);

  return (
    <>
      <CardText>
        As the card administrator, you’ll use this login information to access your True Link
        dashboard, where you can set spending rules, add money to the card, and more.
      </CardText>
      <TrueLinkTextInput
        disabled
        labelText="Your email"
        name="email"
        onChange={onChange}
        placeholder="Your email"
        required
        setFieldTouched={setFieldTouched}
        value={values.email}
      />
      <TrueLinkTextInput
        bottomLabelText="Minimum of 8 characters, including 1 letter, 1 special character, and 1 number"
        endAdornment={
          <PasswordAdornment onClick={handleToggleVisibility} showPassword={showPassword} />
        }
        key={`password-visible-${showPassword}`}
        labelText="Password"
        name="password"
        onChange={onChange}
        placeholder="Password"
        required
        setFieldTouched={setFieldTouched}
        type={showPassword ? 'text' : 'password'}
        value={values.password}
      />
      <TrueLinkTextInput
        key={`passwordConfirmation-visible-${showPassword}`}
        labelText="Re-enter password"
        name="passwordConfirmation"
        onChange={onChange}
        placeholder="Re-enter password"
        required
        setFieldTouched={setFieldTouched}
        type={showPassword ? 'text' : 'password'}
        value={values.passwordConfirmation}
      />
    </>
  );
}

FamilyForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  values: PropTypes.shape({
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    passwordConfirmation: PropTypes.string.isRequired,
  }).isRequired,
};
